import React from 'react'
import Spinner from '@components/Spinner'
import Header from '@components/Header'
import Page from '@components/Page'

export const Loading = () => {
  return <Page header={<Header />} body={<Spinner center />} />
}
